import React from "react";
import { WorkProjectShell } from "./WorkProjectShell";
import {
  WorkSplitRow,
  WorkMediaFrame,
  WorkTextStack,
  WorkSectionHeading,
  ConcludeContainer,
} from "./styles";
import { ProjectDetails } from "../../../DesignSystem/ProjectDetails";

export default function GCAssist() {
  const ProjectBG = require("../../../../assets/videos/gc-assist/poster.png");
  const T1 = require("../../../../assets/videos/gc-assist/t1.png");
  const T2 = require("../../../../assets/videos/gc-assist/t2.png");
  const T3 = require("../../../../assets/videos/gc-assist/t3.png");

  return (
    <WorkProjectShell
      posterSrc={ProjectBG}
      title="GC Assist — 3D & AR product exploration"
      lead={
        <p>
          QR Assist lets users explore a Conel product in interactive 3D and AR:
          internals, measurements, and installation guidance in one flow.
        </p>
      }
    >
      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={T1}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/gc-assist/1_GC+assist.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>3D interactive environment</WorkSectionHeading>
          <p>
            Tap parts in exploded view to understand components and how the
            product works.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow $reverse>
        <WorkMediaFrame>
          <video controls poster={T2}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/gc-assist/2_GC+assist.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Augmented reality</WorkSectionHeading>
          <p>
            Place the model in the real world with the device camera and inspect
            it from every angle.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={T3}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/gc-assist/3_GC+assist+Hololens.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Measurements</WorkSectionHeading>
          <p>
            Read exact dimensions to validate fit and plan installation with
            confidence.
          </p>
          <WorkSectionHeading>Step-by-step installation</WorkSectionHeading>
          <p>
            Guided stages and descriptions reduce errors and save time on site.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <ConcludeContainer>
        <p>
          Built to support purchasing decisions and smoother installs through
          clear 3D and AR guidance.
        </p>
      </ConcludeContainer>

      <ProjectDetails
        details={[
          { label: "Project Name", value: "GC Assist" },
          { label: "Period", value: "07.2019 - 09.2019" },
          { label: "Client", value: "GC Gruppe" },
          { label: "Engine & Tools", value: "Unity, C#" },
          { label: "Platform", value: "Mobile, Hololens, web" },
          { label: "Company", value: "Radiusmedia KG" },
          { label: "Tags", value: "VR, AR, WebGL" },
        ]}
      />
    </WorkProjectShell>
  );
}
